import Survey from './Survey';
import {connect} from 'react-redux';
import {onSubmit} from 'undergraduate-student/actions/survey';

export default connect(null, {onSubmit})(Survey);
